export interface Patient {
  id: string;
  name: string;
  phone: string;
  locationId?: string;
  location?: LocationProvider;
  archived?: boolean;
  updatedAt?: number;
}

export interface LocationProvider {
  id: string;
  name: string;
  phone: string;
}

export interface SearchPatientsResponse {
  result: Patient[];
  /**
   * The next page token to be used in the next request
   */
  nextPage?: string;
}
export interface SearchPatientsRequest {
  search?: string;
  /**
   * The next page token to be used in the next request
   */
  nextPage?: string;
  pageSize?: number;
  /** When true, include archived patients (default excludes them). */
  includeArchived?: boolean | string;
  sort?: 'updatedDesc';
}

export interface GetPatientResponse {
  result?: Patient;
}

export interface GetLocationsResponse {
  result: LocationProvider[];
}

export interface UpdatePatientRequest {
  name?: string;
  phone?: string;
  locationId?: string;
  archived?: boolean;
}

export interface CreateLocationRequest {
  name: string;
  phone: string;
}

export interface UpdateLocationRequest {
  name: string;
  phone: string;
}

export interface OrgAlertHistoryItem {
  id: string;
  patientId: string;
  providerId?: string;
  patientName: string;
  campaignTitle: string;
  callbackLocationName: string;
  contactName: string;
  contactPhone: string;
  initiatedOn: number;
  status: string;
  cancelledAt?: number;
  cancelledReason?: string;
  alertCampaignId?: string;
}

export interface OrgAlertHistoryResponse {
  result: OrgAlertHistoryItem[];
  totalCount: number;
  nextPage?: string;
}

export interface OrgActiveAlert {
  id: string;
  patientId: string;
  initiatedOn: number;
  followUps: number;
  retryAttempts?: number;
  lastAttemptAt: number;
  nextAlertAt?: number;
  scheduledEndAt?: number;
  alertSubject: string;
  contactPhone: string;
  campaignTitle: string;
  alertCampaignId?: string;
}

export interface OrgActiveAlertsResponse {
  /** Newest in-progress cycle per patient. */
  result: OrgActiveAlert[];
}

export const ORG_ALERT_HISTORY_CAMPAIGN_ALL = 'all';
export const ORG_ALERT_HISTORY_CAMPAIGN_MANUAL = 'manual';

export interface OrgAlertHistoryRequest {
  pageSize?: number;
  nextPage?: string;
  /** When `active`, returns live-cycle summaries (see OrgActiveAlertsResponse). */
  status?: 'active';
  campaignId?: string;
  dateFrom?: number;
  dateTo?: number;
  search?: string;
}

